// biome-ignore-all lint/suspicious/noConsole: these fallbacks warn until trackerInterfaceInit runs
/** Event properties sent to the analytics provider. */
export type TrackingProperties = { readonly [property: string]: unknown };

export interface TrackerInterface {
  identify: (userId: string) => void;
  getIdentity: () => string | undefined;
  timeEvent: (event: string) => void;
  track: (event: string, properties: TrackingProperties) => void;
  updateProfile: (properties: TrackingProperties) => void;
  /** Properties added to every tracked event. */
  dynamicDefaultProperties: () => TrackingProperties | undefined;
  trackEventTTI: (event: string, properties: TrackingProperties) => void;
}

// TODO: replace console.error with logger
let identifyInterface: TrackerInterface['identify'] = () =>
  console.warn('initialize identifyInterface with trackerInterfaceInit first...');
let getIdentityInterface: TrackerInterface['getIdentity'] = () => {
  console.warn('initialize getIdentityInterface with trackerInterfaceInit first...');
  return undefined;
};
let timeEventInterface: TrackerInterface['timeEvent'] = () =>
  console.warn('initialize trackTimeInterface with trackerInterfaceInit first...');
let trackInterface: TrackerInterface['track'] = () =>
  console.error('initialize trackInterface with trackerInterfaceInit first...');
let updateProfileInterface: TrackerInterface['updateProfile'] = () =>
  console.warn('initialize updateProfileInterface with trackerInterfaceInit first...');
let dynamicDefaultPropertiesInterface: TrackerInterface['dynamicDefaultProperties'] = () => {
  console.warn('initialize dynamicDefaultPropertiesInterface with trackerInterfaceInit first...');
  return undefined;
};
let trackEventTTIInterface: TrackerInterface['trackEventTTI'] = () =>
  console.warn('initialize trackEventTTIInterface with trackerInterfaceInit first...');

export const trackerInterfaceInit = ({
  identify,
  getIdentity,
  timeEvent,
  track,
  updateProfile,
  dynamicDefaultProperties,
  trackEventTTI,
}: Partial<TrackerInterface>): void => {
  identifyInterface = identify || identifyInterface;
  getIdentityInterface = getIdentity || getIdentityInterface;
  timeEventInterface = timeEvent || timeEventInterface;
  trackInterface = track || trackInterface;
  updateProfileInterface = updateProfile || updateProfileInterface;
  dynamicDefaultPropertiesInterface = dynamicDefaultProperties || dynamicDefaultPropertiesInterface;
  trackEventTTIInterface = trackEventTTI || trackEventTTIInterface;
};

export const identify: TrackerInterface['identify'] = (userId) => identifyInterface(userId);
export const getIdentity: TrackerInterface['getIdentity'] = () => getIdentityInterface();
export const timeEvent: TrackerInterface['timeEvent'] = (event) => timeEventInterface(event);
export const track: TrackerInterface['track'] = (event, props) => trackInterface(event, props);
export const updateProfile: TrackerInterface['updateProfile'] = (props) => updateProfileInterface(props);
export const dynamicDefaultProperties: TrackerInterface['dynamicDefaultProperties'] = () =>
  dynamicDefaultPropertiesInterface();
export const trackEventTTI: TrackerInterface['trackEventTTI'] = (event, props) => trackEventTTIInterface(event, props);
